import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const UNIT_CARD_COUNT: number = 9;
const PILL_COUNTS_PER_CARD: number[] = [1, 2, 1, 1, 2, 1, 1, 2, 1];

// Mirrors the layout of BulkActivateWalkthroughs / BulkAddWalkthroughs:
// Activation Settings section (label + 2 toggles), Units grid (label + helper +
// .units-grid of .unit-card items each with checkbox + info-stack + pills),
// then a footer with Cancel + primary action.
const BulkWalkthroughsDialogueSkeleton = () => (
  <div
    style={{
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      padding: '0.5rem 0.25rem',
    }}
  >
    {/* 1. Activation Settings section. */}
    <div style={{ marginBottom: '1.5rem' }}>
      <div style={{ marginBottom: '0.5rem' }}>
        <Skeleton variant="text" width="10rem" />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
          <Skeleton variant="rect" width="1rem" height="1rem" />
          <Skeleton variant="text" width="14rem" />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
          <Skeleton variant="rect" width="1rem" height="1rem" />
          <Skeleton variant="text" width="18rem" />
        </div>
      </div>
    </div>

    {/* 2. Units selection section: label + helper + grid of unit cards. */}
    <div style={{ marginBottom: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
      <div style={{ marginBottom: '0.4rem' }}>
        <Skeleton variant="text" width="6rem" />
      </div>
      <div style={{ marginBottom: '0.75rem' }}>
        <Skeleton variant="text" width="60%" />
      </div>
      <div className="units-grid">
        {Array.from({ length: UNIT_CARD_COUNT }, (_, index: number) => (
          <UnitSelectionCardSkeleton
            key={`bulk-unit-skeleton-${index}`}
            pillCount={PILL_COUNTS_PER_CARD[index] ?? 1}
          />
        ))}
      </div>
    </div>

    {/* 3. Footer actions. */}
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '0.75rem',
        marginTop: 'auto',
        paddingTop: '1.5rem',
      }}
    >
      <Skeleton variant="rect" width="6rem" height="2.25rem" />
      <Skeleton variant="rect" width="11rem" height="2.25rem" />
    </div>
  </div>
);

interface UnitSelectionCardSkeletonProps {
  pillCount: number;
}

const UnitSelectionCardSkeleton = ({ pillCount }: UnitSelectionCardSkeletonProps) => (
  <div className="unit-card">
    <div style={{ marginRight: '12px' }}>
      <Skeleton variant="rect" width="1.1rem" height="1.1rem" />
    </div>
    <div className="unit-card-content">
      <div className="unit-info-stack">
        <Skeleton variant="text" width="3.5rem" />
        <Skeleton variant="text" width="5rem" />
        <Skeleton variant="text" width="4rem" />
      </div>
      <div className="unit-pills-stack">
        {Array.from({ length: pillCount }, (_, pillIndex: number) => (
          <div key={`pill-${pillIndex}`} className="unit-pill-wrapper">
            <Skeleton variant="rect" width="5rem" height="1.1rem" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default BulkWalkthroughsDialogueSkeleton;
